// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"73b92ee4","255":"2cf48c47","259":"cdb9cb3e","308":"4705dbc3","548":"a9e4b12d","775":"4ef6dce4","841":"3bb48be2"}[chunkId] + ".chunk.js";
};